import { queryOptions } from '@tanstack/vue-query'
import { merge } from 'lodash'
import { queryClient } from '@/plugins/tanstack'
import { getScreensV3, getScreensV1 } from '@/common/services/ScreenService'
import localizationServerData from '@/common/services/serverData/localizationServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { type FetchOptionBase, SERVER_DATA_LABELS, SERVER_DATA_SCOPE } from '@/common/types/cacheConstants'
import { type ListScreensParamsV1 } from '@/common/types/screen'

/**
 * V1
 */
/**
 * @deprecated
 */
function groupOptionsV1(params: ListScreensParamsV1) {
  return queryOptions({
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SCREENS_V1,
      params,
    }),
    staleTime: Infinity,
    queryFn: () => {
      return getScreensV1(params)
    },
  })
}

interface FetchOptionV1 extends FetchOptionBase {
  params: ListScreensParamsV1
}
/**
 * @deprecated
 */
async function fetchV1(options: FetchOptionV1) {
  const { params, staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(merge(groupOptionsV1(params), { staleTime })),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SCREENS_V1,
      staleTime,
    }),
  ])
  return result
}

/**
 * @deprecated
 */
function invalidateV1() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SCREENS_V1,
    }),
  ])
}

/**
 * V3
 */
function groupOptionsV3() {
  return queryOptions({
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SCREENS_V3,
    }),
    staleTime: Infinity,
    queryFn: getScreensV3,
  })
}

async function fetchV3(options: FetchOptionBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(merge(groupOptionsV3(), { staleTime })),
    localizationServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SCREENS_V3,
      staleTime,
    }),
  ])
  return result
}

function invalidateV3() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SCREENS_V3,
    }),
  ])
}

export default {
  // V1
  fetchV1,
  groupOptionsV1,
  invalidateV1,
  // V3
  fetchV3,
  groupOptionsV3,
  invalidateV3,
}
